import BlogItemEntity from '../BlogItemEntity.js';
import {Element} from '@chaysehartsuff/active-html';
import {Button} from '@chaysehartsuff/active-html';
import {Color} from '@chaysehartsuff/active-html';
import {PencilIcon} from '@chaysehartsuff/active-html';

export default class BlogHeader extends BlogItemEntity {

    title;
    readMin;
    author;
    tag;
    publish_date;
    header_image;
    meta_data = {};

    constructor(meta_data = {}) {
        super('');

        // base styling
        this.addClass(' mb-6 pb-1 ql-font-raleway');


        // delcare UI components
        this.title = new Element().addClass('text-4xl font-bold mb-2');
        this.readMin = new Element().addClass('text-sm text-gray-500 mb-2 float-right');
        this.author = new Element().addClass('text-sm text-gray-500 mb-2');
        this.tag = new Element().addClass('mt-1 w-1/2 inline-flex flex-wrap gap-2');
        this.publish_date = new Element().addClass('float-right text-sm text-gray-500 mb-2');
        this.header_image = new Element('img').addClass('w-full mt-2 h-64 object-cover rounded-lg mb-4');

        this.setContent(this.title);
        this.addContent(this.readMin);
        this.addContent(this.author);
        this.addContent(this.tag);       
        this.addContent(this.publish_date); 
        this.addContent(this.header_image);

        this.updateMetaDataUI(meta_data);
    }

    /**
     * Refreshes the UI components for edit/view based on current meta_data
     */
    updateMetaDataUI(meta_data = {}){
        this.meta_data = meta_data;
        if(meta_data.hasOwnProperty('title'))
            this.title.setContent(meta_data.title);
        if(meta_data.hasOwnProperty('read_mins'))
            this.readMin.setContent(`${meta_data.read_mins} minute read`);
        if(meta_data.hasOwnProperty('author_name'))
            this.author.setContent(`By ${meta_data.author_name}`);
        if(meta_data.hasOwnProperty('tags')){
            this.tag.clearContent();

            if (Array.isArray(meta_data.tags) && meta_data.tags.length > 0) {
                meta_data.tags.forEach((tag) => {
                    this.tag.addContent(
                        new Element('span')
                            .addClass('inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full')
                            .addContent(tag)
                    );
                });
            } else {
                this.tag.addContent(
                    new Element('span')
                        .addClass('text-xs text-gray-500')
                        .addContent('No tags')
                );
            }
        }
        if(meta_data.hasOwnProperty('publish_date'))
            this.publish_date.setContent(this.getPrettyDate(meta_data.publish_date));
        if(meta_data.hasOwnProperty('header_image'))
            this.header_image.setAttribute('src', meta_data.header_image);
    }


    getPrettyDate(date){
        return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    compilePreview() {
        let tagsContent = new Element().addClass('blog-header tags');
        if (Array.isArray(this.meta_data.tags) && this.meta_data.tags.length > 0) {
            for (const tag of this.meta_data.tags) {
                tagsContent.addContent(
                    new Element('span')
                        .addClass('blog-header tag')
                        .addContent(tag)
                );
            }
        }

        return new Element()
        .addClass('blog-header container')
        .addContent(
            new Element('h1').addClass('blog-header title').addContent(this.meta_data.title)
        )
        .addContent(
            new Element('div').addClass('blog-header read-mins').addContent(`${this.meta_data.read_mins} minute read`)
        )
        .addContent(
            new Element('div').addClass('blog-header author').addContent(`By ${this.meta_data.author_name}`)
        )
        .addContent(
            tagsContent
        )
        .addContent(
            new Element('div').addClass('blog-header publish-date').addContent(this.getPrettyDate(this.meta_data.publish_date))
        )
        .addContent(
            new Element('img').addClass('blog-header header-image').setAttribute('src', this.meta_data.header_image)
        )
        .compile()
        ;
    }

    importObject(obj){
        super.importObject(obj);
        this.updateMetaDataUI(this.meta_data);
    }
}